import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { endpoints } from 'Core/defaultValues';


const url = `${endpoints.CAR_IQ_URL}/?ssosource=gpstrackit&ssoaccesstoken=${localStorage.getItem('IdToken')}`
let isLoad = false


const CarIQ = () => {
  const carIQRef = useRef();
  const dispatch = useDispatch()
  const { refreshTokenResult } = useSelector((state) => state.securityRedux);

  useEffect(() => {
    if (refreshTokenResult && isLoad) {
      const newToken = localStorage.getItem('IdToken')
      if (carIQRef?.current) {
        carIQRef?.current?.contentWindow.postMessage({
          "idToken": newToken
        }, url);
      }
    }
  }, [refreshTokenResult]);


  useEffect(() => {
		window.addEventListener("message", eventMessages, false);
		//GerVersionFromServer()

		//component unmount
		return () => {
			//props.setToggleFullScreen(false)
			window.removeEventListener("message", eventMessages, false);
		}
	})

  const eventMessages = (event) => {
		// console.log('event', event)
	}

  return (
    <div style={{ height: "98vh" }}>
      <iframe
        id="car-iq"
        ref={carIQRef}
        title="Car IQ"
        width="100%"
        height="100%"
        src={url}
        onLoad={() => {
          isLoad = true
        }}
      ></iframe>
    </div>
  );
};

export default CarIQ;
